import { useMutation } from '@apollo/client';
import { Card } from 'antd';
import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { EXPORT_TYPES, MODULES } from '../../../../../common/constants';
import Portal from '../../../../../components/Portal';
import EndUsersTable from '../components/UserOrders';
import { REQUEST_NEW_ORDER_EXPORT } from '../graphql/Mutations';

const UserOrders = () => {
  const [exportFilter, setExportFilter] = useState();
  const [isExportLoading, setIsExportLoading] = useState(false);

  const [requestOrderExport] = useMutation(REQUEST_NEW_ORDER_EXPORT, {
    onError: () => {},
  });

  const { userId } = useParams();

  const handleExport = async () => {
    setIsExportLoading(true);
    await requestOrderExport({
      variables: {
        data: {
          type: EXPORT_TYPES?.NEW_ORDERS,
        },
        filter: {
          search: exportFilter?.search,
          deliveryType: exportFilter?.deliveryType,
          orderIds: exportFilter?.orderNumber,
          dateRange: {
            from: exportFilter?.createdAt?.from?.$d,
            to: exportFilter?.createdAt?.to?.$d,
          },
          pincodeIds: exportFilter?.pincodes,
        },
      },
    });
    setIsExportLoading(false);
  };

  return (
    <>
      <Portal portalId="header-title-content">
        <div className="portal-header">{MODULES?.COMBINED_ORDERS}</div>
      </Portal>

      <Card className="mobile-with-search-action-container">
        <EndUsersTable userId={userId} />
      </Card>
    </>
  );
};

export default UserOrders;
